/**
 * Textos de ayuda en español por `route.name` (vue-router).
 * Cada entrada: `summary` (tooltip corto) y `paragraphs` (párrafos del diálogo).
 */

const BY_NAME = {
  home: {
    summary: 'Panel de accesos rápidos del administrador',
    paragraphs: [
      'Desde el inicio entras a las áreas más usadas: usuarios, informes, preguntas y catálogos.',
      'El menú (icono de barras arriba a la derecha) repite las mismas rutas por si prefieres listado.',
    ],
  },
  'admin-alumno': {
    summary: 'Buscar, editar y gestionar usuarios del sistema',
    paragraphs: [
      'Aquí consultas la lista de usuarios, filtras por criterios y abres el detalle para editar datos o contratos.',
      'Los cambios sensibles suelen pedir confirmación. Si aparece un error, revisa el mensaje o usa el bloc de pruebas (portapapeles en la barra).',
    ],
  },
  'admin-asignatura': {
    summary: 'Asignaturas asociadas a cada usuario',
    paragraphs: [
      'Permite revisar o ajustar qué asignaturas tiene contratado cada alumno o perfil según las reglas del negocio.',
      'Selecciona usuario y revisa las asignaturas antes de guardar cambios masivos.',
    ],
  },
  'admin-uso': {
    summary: 'Centro de informes de uso y estadísticas',
    paragraphs: [
      'Desde aquí enlazas a informes de uso por curso, videos, tests, prácticas y otros reportes.',
      'Cada subpantalla tiene sus propios filtros (fechas, colegio, curso, etc.).',
    ],
  },
  'uso-curso': {
    summary: 'Conexiones y tiempo de uso por colegio y curso',
    paragraphs: [
      'Elige colegio y curso, define un rango de fechas y genera el informe de usabilidad (conexiones, tiempo, última conexión).',
      'La tabla es paginada: usa el paginador inferior para ver más registros.',
    ],
  },
  'uso-video': {
    summary: 'Uso de videos y resumen por alumno',
    paragraphs: [
      'Filtra por colegio, curso y fechas para ver consumo de videos y totales por usuario.',
      'Útil para detectar cursos con poca visualización.',
    ],
  },
  'uso-test': {
    summary: 'Interacción con evaluaciones tipo test',
    paragraphs: [
      'Muestra actividad de los alumnos en tests según colegio, curso y periodo.',
      'Complementa los informes de cumplimiento de pruebas en el menú de uso.',
    ],
  },
  'uso-practica': {
    summary: 'Prácticas resueltas por curso',
    paragraphs: [
      'Informe de prácticas para un curso concreto: respuestas, correctas/incorrectas y fechas.',
      'Asegúrate de elegir colegio, curso y rango de fechas válido antes de generar.',
    ],
  },
  'uso-practica-multiple': {
    summary: 'Prácticas con varios cursos y asignaturas',
    paragraphs: [
      'Permite cruzar varios cursos y asignaturas en un mismo colegio para ver prácticas y exportar a Excel.',
      'Los listados de curso/asignatura dependen del colegio seleccionado.',
    ],
  },
  'cumplimiento-practicas': {
    summary: 'Porcentaje de cumplimiento de prácticas',
    paragraphs: [
      'Resume el avance o cumplimiento de prácticas según los filtros definidos en la pantalla.',
      'Útil para seguimiento académico por periodo.',
    ],
  },
  'uso-alumnos': {
    summary: 'Vista de uso general de alumnos',
    paragraphs: [
      'Consulta métricas o listados de uso de alumnos según los filtros disponibles en esta vista.',
    ],
  },
  'notificar-alumnos': {
    summary: 'Envío de correos o push a usuarios',
    paragraphs: [
      'Selecciona colegio y cursos, busca usuarios y elige el tipo de notificación (email, push, etc.).',
      'Revisa bien la selección antes de confirmar envíos masivos.',
    ],
  },
  'actualiza-masivo-casas-alumno': {
    summary: 'Cambio masivo de casa / curso casa',
    paragraphs: [
      'Herramienta para actualizar la casa (ej. A, B, Lancaster) de muchos alumnos a la vez mediante archivo o selección.',
      'Haz una prueba con pocos registros antes de un lote grande.',
    ],
  },
  'informe-interaccion-total': {
    summary: 'Interacción agregada en el periodo',
    paragraphs: [
      'Informe consolidado de interacción (varias dimensiones) para el colegio y cursos seleccionados.',
      'Revisa fechas y filtros; el resultado puede tardar en cargas grandes.',
    ],
  },
  'informe-interaccion-juego': {
    summary: 'Uso de juegos educativos',
    paragraphs: [
      'Muestra interacciones con juegos filtradas por colegio, cursos y fechas.',
    ],
  },
  'informe-cumplimiento-juego': {
    summary: 'Cumplimiento y ranking en juegos',
    paragraphs: [
      'Enfocado en cumplimiento o top de alumnos en juegos según periodo y filtros.',
    ],
  },
  'informe-visualizacion-video': {
    summary: 'Visualizaciones de video (simple o múltiple)',
    paragraphs: [
      'Analiza cuántas veces se vieron videos y por quién, con opciones de filtro por colegio/cursos/fechas.',
    ],
  },
  'informe-interaccion-test': {
    summary: 'Interacción con pruebas tipo SIMCE/test',
    paragraphs: [
      'Detalle de intentos o interacciones con tests en el rango y colegio indicados.',
    ],
  },
  'informe-cumplimiento-test': {
    summary: 'Cumplimiento de evaluaciones test',
    paragraphs: [
      'Resumen de cumplimiento o ranking en pruebas según los filtros de la pantalla.',
    ],
  },
  'admin-masivo': {
    summary: 'Menú de tareas masivas (carga de datos)',
    paragraphs: [
      'Punto de entrada a importaciones masivas: alumnos, apoderados, profesores, videos, capítulos, etc.',
      'Cada subopción abre su propio flujo; respeta plantillas y formatos indicados en cada pantalla.',
    ],
  },
  'ingreso-masivo-alumno': {
    summary: 'Importación masiva de alumnos',
    paragraphs: [
      'Sube el archivo según la plantilla del sistema y valida errores antes de confirmar.',
      'Los duplicados o RUT inválidos suelen rechazarse fila a fila.',
    ],
  },
  'ingreso-masivo-apoderado': {
    summary: 'Importación masiva de apoderados',
    paragraphs: [
      'Asocia apoderados a alumnos respetando el formato requerido por el importador.',
    ],
  },
  'ingreso-masivo-profesor': {
    summary: 'Importación masiva de profesores',
    paragraphs: [
      'Carga de docentes en bloque; verifica columnas obligatorias y colegio de destino.',
    ],
  },
  'ingreso-masivo-videos': {
    summary: 'Alta masiva de videos',
    paragraphs: [
      'Registra muchos videos a la vez (metadatos, URLs o IDs según corresponda al integrador).',
    ],
  },
  'ingreso-masivo-capitulos': {
    summary: 'Alta masiva de capítulos',
    paragraphs: [
      'Importa capítulos o estructura de unidades en lote; conviene probar con un archivo pequeño.',
    ],
  },
  'ingreso-masivo-preguntas': {
    summary: 'Importación masiva de preguntas (clásico)',
    paragraphs: [
      'Flujo heredado para cargar preguntas desde archivo; revisa mapeo de columnas y banco destino.',
    ],
  },
  'relacion-video-capitulo': {
    summary: 'Vincular videos con capítulos',
    paragraphs: [
      'Establece o corrige la relación entre recursos de video y nodos del árbol de capítulos.',
    ],
  },
  'ingreso-jefaturas': {
    summary: 'Carga o edición de jefaturas',
    paragraphs: [
      'Gestión de jefaturas o niveles jerárquicos usados en el colegio según la lógica de esta pantalla.',
    ],
  },
  'reporte-imagenes-preguntas': {
    summary: 'Auditoría de imágenes en preguntas',
    paragraphs: [
      'Lista preguntas con problemas de imagen o para revisar glosa y metadatos visualmente.',
      'Puedes corregir glosa o disparar acciones según los botones disponibles.',
    ],
  },
  'admin-preguntas': {
    summary: 'Administración clásica de preguntas',
    paragraphs: [
      'Mantenimiento de preguntas en el formato histórico del sistema.',
    ],
  },
  'ingreso-preguntas-nuevo': {
    summary: 'Ingreso y edición de preguntas (flujo nuevo)',
    paragraphs: [
      'Crea o edita preguntas por unidad/capítulo con vista previa y validaciones.',
      'Guarda borradores antes de publicar cambios sensibles.',
    ],
  },
  'ingreso-preguntas-simce': {
    summary: 'Carga de preguntas estilo SIMCE / matriz',
    paragraphs: [
      'Herramientas específicas para ítems SIMCE o matrices según la configuración del proyecto.',
    ],
  },
  'mantenedor-habilidades': {
    summary: 'Catálogo de habilidades de preguntas',
    paragraphs: [
      'Alta, edición y listado de habilidades que luego se asocian a preguntas.',
    ],
  },
  'capitulos-no-vigente': {
    summary: 'Capítulos marcados como no vigentes',
    paragraphs: [
      'Consulta o gestiona capítulos que ya no deben mostrarse en la app de alumnos.',
    ],
  },
  'orden-capitulos-en-unidades': {
    summary: 'Renumerar y ordenar capítulos por unidad',
    paragraphs: [
      'Selecciona curso y asignatura, asigna un número de orden a cada capítulo (grupo) y guarda por unidad.',
      'El sistema reescribe prefijos en glosas; revisa el resultado después de guardar.',
    ],
  },
  'mantenedor-capitulos': {
    summary: 'ABM de capítulos',
    paragraphs: [
      'Crea, edita o desactiva capítulos del catálogo académico.',
    ],
  },
  'mantenedor-unidades': {
    summary: 'ABM de unidades',
    paragraphs: [
      'Administra unidades didácticas vinculadas a la estructura de contenidos.',
    ],
  },
  'mantenedor-asignaturas': {
    summary: 'ABM de asignaturas',
    paragraphs: [
      'Mantén nombres, vigencia y datos de asignaturas usadas en cursos y contratos.',
    ],
  },
  'mantenedor-videos': {
    summary: 'ABM de videos',
    paragraphs: [
      'Gestiona metadatos, vigencia y enlaces de videos del catálogo.',
    ],
  },
  'mantenedor-contratos': {
    summary: 'Contratos o planes asociados a usuarios',
    paragraphs: [
      'Revisa cabeceras y detalles de contrato para alinear acceso a asignaturas o periodos.',
    ],
  },
  'admin-alumnos-nuevo': {
    summary: 'Alta o edición de un usuario',
    paragraphs: [
      'Formulario de nuevo alumno o edición según la URL. Completa datos personales, acceso y asignaturas si aplica.',
    ],
  },
};

/**
 * @param {{ name?: string, meta?: { formulario?: string } }} route
 * @returns {{ summary: string, paragraphs: string[] } | null}
 */
export function getScreenHelp(route) {
  if (!route || route.name === 'login' || route.name === 'logout') return null;
  const specific = BY_NAME[route.name];
  if (specific) return specific;
  const titulo = route.meta?.formulario;
  if (titulo) {
    return {
      summary: `Ayuda: ${titulo}`,
      paragraphs: [
        `Estás en «${titulo}». Usa los campos y botones de la página para completar la tarea.`,
        'Si algo falla, abre el bloc de pruebas (icono de portapapeles en la barra), reproduce el error y copia el texto para enviarlo a soporte.',
      ],
    };
  }
  return null;
}
